import {objUtil} from "./objectUtils"
import { typeUtil } from "./typeUtils";
type StringOrUndefined= typeUtil.StringOrUndefined;
const isNullOrEmpty=objUtil.isNullOrEmpty;

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace urlUtil {
    export const getUrlQueryStringValue = (name: string): StringOrUndefined => {
        const urlParams = new URLSearchParams(window.location.search)
        const data = urlParams.get(name);
        return data ? data : undefined;

    }
    export const getWindowUrlString = (): StringOrUndefined => {

        return window?.location?.toString();
    }

    export const getDocumentReferrer = (): StringOrUndefined => {
        const data = document?.referrer;
        return isNullOrEmpty(data) ? undefined : data;
    }

    export const getHostNameFromUrl = (): StringOrUndefined => {
        return window?.location?.host
    }

    export const getUrlQueryStringValues = (names: Array<string>): Map<string, StringOrUndefined> => {
        const urlParams = new URLSearchParams(window.location.search)
        const result = new Map<string, StringOrUndefined>();
        names.map(q => {
            const data = urlParams.get(q);
            result.set(q, data ? data : undefined);
        })
        return result;
    }
    export const getUrlQueryStringAllParams = (): Map<string, StringOrUndefined> => {
        const result = new Map<string, StringOrUndefined>();
        const urlParams = new URLSearchParams(window.location.search)
        for (const [key, value] of urlParams) {
            result.set(key, value);
        }
        return result;
    }
}